import {$fetch} from "ofetch";
import {parseCookies} from "h3";
export const $larafetch = $fetch.create({
    credentials: "include",
    async onRequest({request, options}) {
        const {API_URL, APP_URL} = useRuntimeConfig().public;
        const event = typeof useEvent === "function" ? useEvent() : null;
        let token = event
            ? parseCookies(event)['auth_token']
            : useCookie('auth_token').value;
        const socket = useState('socket', () => null)


        if (token) {
            options.headers = {
                Authorization: 'Bearer ' + token
            }
        }

        if (socket.value) {
            options.headers = {
                ...options.headers,
                'X-Socket-Id': socket.value
            }
        }

        options.headers = {
            Accept: "application/json",
            Referer: APP_URL,
            ...options?.headers,
        };
        options.baseURL = API_URL;
    },
    async onResponse({response}) {

    },
    async onResponseError({response}) {
        const status = response.status;
        if ([500].includes(status)) {
            console.error("[Laravel Error]", response.statusText, response._data);
        }
    },
});